import ControlErrorDisplay from "components/common/ControlErrorDisplay";
import ControlSuccessDisplay from "components/common/ControlSuccessDisplay";

interface Props {
  message: string;
  variant: "success" | "error";
}

export default function ControlInformationDisplay(props: Props) {
  const { message, variant } = props;
  return (
    <>
      {variant === "success" ? (
        <ControlSuccessDisplay message={message} />
      ) : (
        <ControlErrorDisplay message={message} />
      )}
    </>
  );
}
